<template>
  <div :class="['select-custom', { error: isValidate }]">
    <label v-if="title">
      {{ title }}<span v-if="isRequired" class="text-danger">*</span>
    </label>
    <br v-if="title" />
    <b-dropdown variant="outline" dropright class="filter-custom">
      <template v-slot:button-content>
        <img
          v-if="displayData.imageUrl"
          :src="displayData.imageUrl"
          :alt="displayData.name"
          height="14"
          class="mr-2 mb-1"
        /><span class="text-left">{{ displayData.name }}</span>
      </template>
      <b-dropdown-item
        v-for="(item, index) in options"
        v-bind:key="index"
        class="border-bottom pointer p-0"
        @click="onDataChange(item)"
      >
        <img
          v-if="item[valueField] > 0"
          :src="item.imageUrl"
          :alt="item.name"
          height="14"
          class="mr-1"
        /><span class="text-left">{{ item.name }}</span>
      </b-dropdown-item>
    </b-dropdown>
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">{{
        `Please ${options[0][textField || "text"]}`
      }}</span>
      <span class="text-error" v-else-if="v.minValue == false">{{
        options[0][textField || "text"]
      }}</span>
      <span class="text-error" v-else-if="v.sameAsSelect == false"
        >ตัวเลือกนี้ถูกเลือกแล้ว กรุณาเลือกใหม่เนื่องจากเลือกซ้ำกัน</span
      >
      <span class="text-error" v-else-if="v.SameAsSelectMainId == false"
        >ไม่สามารถเลือกตัวเลือกนี้ได้ กรุณาเลือกใหม่</span
      >
      <span class="text-error" v-else-if="v.SameAsSelectedReplyType == false"
        >ไม่สามารถเลือกซ้ำได้</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: false,
      type: String,
    },
    text: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
    },
    name: {
      required: false,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    value: {
      required: false,
      type: [String, Number],
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    valueField: {
      required: false,
      type: String,
    },
    textField: {
      required: false,
      type: String,
    },
    v: {
      required: false,
      type: Object,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    platformConfigId: {
      require: false,
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    displayData() {
      let displayData = {
        platformConfigId: 0,
        imageUrl: "",
        name: "",
      };
      let platformConfigId = this.platformConfigId;
      if (typeof this.value !== "undefined") {
        platformConfigId = this.value;
      }
      let platformConfig = this.options.find(
        (platformConfig) => platformConfig[this.valueField] === platformConfigId
      );
      displayData.platformConfigId = platformConfig.platformConfigId;
      displayData.imageUrl = platformConfig.imageUrl;
      displayData.name = platformConfig.name;
      return displayData;
    },
  },
  methods: {
    onDataChange(event) {
      this.displayData.name = event.name;
      this.displayData.imageUrl = event.imageUrl;
      this.displayData.platformConfigId = event.platformConfigId;
      this.$emit("onDataChange", event[this.valueField]);
    },
  },
};
</script>

<style scoped>
.select-custom {
  margin-bottom: 15px;
  position: relative;
  white-space: nowrap;
}
.select-custom.error > .btn-select {
  border-color: red !important;
}
.select-custom > label {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
::v-deep .btn-select {
  color: #404040;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 5px 10px;
  cursor: pointer;
}
::v-deep .btn-select.custom-select-lg {
  height: 45px;
  font-size: 1rem;
}
::v-deep .btn-select:focus {
  border-color: #242424;
}
::v-deep .btn-select > option {
  background-color: white;
  color: #242424;
}
::v-deep .btn-select > option:checked {
  /* background-color: #242424 !important;  */
  /* background-color: #80c141 !important; */
  /* color: white !important; */
  color: #242424 !important;
}
::v-deep .btn-select:focus {
  box-shadow: unset !important;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
@media (max-width: 767.98px) {
  .select-custom {
    margin-top: 0;
  }
  .select-custom > label {
    font-size: 15px;
  }
}
</style>
